export enum FilterType {
    ForloebFilter = 0,
    EvalueringsstatistikFilter= 1
}

